import React from 'react';
import BILLoader from '../../components/BILLoader/BILLoader';
import { useEffect, useState } from "react";
import { RedocStandalone } from 'redoc';

const Documentation = (props) => {

  const [isLoading, setLoading] = useState(true);

  useEffect(() => {
    setTimeout(() => { setLoading(false) }, 700)
  }, []);

  if (isLoading) {

    return (
      <div className="intl-spinner-container">
        <BILLoader />
      </div>
    )
  }

  return (
    <>
      <div className="intl-spinner-container">
        <BILLoader />
      </div>
      <div style={{ marginTop: "1px" }}>
        <RedocStandalone
          specUrl={props.swaggerConfig}
          options={{
            jsonSampleExpandLevel: "all",
            hideLoading: true,
            disableSearch: true,
            hideSecuritySection: true,
            theme: { colors: { primary: { main: '#702fa8' } } }
          }}
          onLoaded={error => {
            //Remove loader
            if (document.getElementById("bil-loader") !== null) {
              document.getElementById("bil-loader").remove();
            }
            //Scroll to top on loading
            document.getElementById("root").scrollIntoView()
            //Delete powered info
            document.querySelectorAll('a').forEach((a) => {
              if (a.href === "https://redocly.com/redoc/") {
                a.parentElement.removeChild(a);
              }
            })
          }}
        />
      </div>
    </>
  );
}

export default Documentation;